import { useState } from 'react';

export default function useTabState<T>(initial: T) {
  const [state, setState] = useState<T>(initial);
  const onChange = async (tab: T) => setState(tab);

  const returnState: [typeof state, typeof onChange] = [state, onChange];
  return returnState;
}
